import { AllowedCurrencyCode } from '@nrdy-marketing-engine/cart/@types/cart-state';
import { CatalogItem } from '@nrdy-marketing-engine/cart/@types/catalog-item';
import { z } from 'zod';
import { CURRENCY_CODE_MAP } from '../../constants/currency-code-map';
import { jurisdictionToCountryCode } from '../country-code/jurisdiction-to-country-code';

function itemDuration(duration: number, durationUnit: string = 'month') {
  if (typeof duration === 'number' && duration > 1) return `${duration} ${durationUnit}s`;
  return durationUnit;
}

interface CatalogItemMetadata {
  currencyCode: AllowedCurrencyCode;
  formattedDescriptionPricePresent: boolean;
  itemPriceDuration: string | number;
  normalizedItem?: CatalogItem;
  originalPrice: number;
  price: number;
}

interface CatalogMetadataInput {
  cartJurisdictionId: number;
  cartPrice: number;
  item: CatalogItem;
}

const CatalogItemMetadataSchema = z.object({
  currencyCode: z.string().default('USD'),
  formattedDescriptionPricePresent: z.boolean().default(false),
  itemPriceDuration: z.union([z.string(), z.number()]).default(''),
  normalizedItem: z.any().default(null),
  originalPrice: z.number().default(0),
  price: z.number().default(0),
});

export function getCatalogItemPriceMetadata(data: CatalogMetadataInput): CatalogItemMetadata {
  const currencyCode =
    CURRENCY_CODE_MAP[jurisdictionToCountryCode(data.cartJurisdictionId) || 'US'];

  const item = data?.item;

  return CatalogItemMetadataSchema.parse({
    currencyCode,
    formattedDescriptionPricePresent: item?.price_in_description_formatted,
    itemPriceDuration: item?.price_in_description_formatted
      ? item?.subscription.duration
      : itemDuration(item?.subscription.duration as number),
    normalizedItem: item,
    originalPrice: item?.price_cents,
    price: data.cartPrice,
  }) as CatalogItemMetadata;
}
